import { Box, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { usePlansStyles } from './styles/usePlansStyles';

interface PlansLayoutProps {
  title: string | (() => ReactNode);
  subtitle: string | (() => ReactNode);
  children: ReactNode | undefined;
  titleSpacing?: 'xs' | 'lg';
  contentGap?: 'xs' | 'lg';
}

function PlansLayout({
  title,
  subtitle,
  children,
  titleSpacing = 'lg',
  contentGap = 'lg',
}: Readonly<PlansLayoutProps>) {
  const styles = usePlansStyles(titleSpacing, contentGap);

  return (
    <Box sx={styles.titleContainer}>
      <Box sx={styles.descriptionContainer}>
        {typeof title === 'string' ? (
          <Typography variant="large_heading_30_semibold" sx={styles.title}>
            {title}
          </Typography>
        ) : (
          title()
        )}
        {typeof subtitle === 'string' ? (
          <Box sx={styles.subtitleContainer}>
            {subtitle.split('\n').map((line) => (
              <Typography
                key={line}
                variant="body_14_regular"
                sx={styles.subtitle}
                component="div"
              >
                {line}
              </Typography>
            ))}
          </Box>
        ) : (
          subtitle()
        )}
      </Box>
      <Box sx={styles.contentContainer}>{children}</Box>
    </Box>
  );
}

export default PlansLayout;
